"use client";
import localforage from "localforage";
import { LS_USER_PREFERENCES } from "./constants.js";
const LOCAL_STORAGE_KEY = "user_preferences";
const STW_MY_WAREHOUSE_LOCAL_STORAGE_KEY = "stwMyWarehouse";
const STW_POSTAL_CODE_LOCAL_STORAGE_KEY = "stwPostalCode";
const userPreferencesLocalForage = localforage.createInstance({
  description: "Costco Wholesale User Preferences",
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
  name: "CW_user_preferences",
  storeName: "cache",
  version: 1
});
async function read(key) {
  try {
    const persisted = await userPreferencesLocalForage.getItem(key);
    if (persisted) {
      return JSON.parse(persisted);
    }
  } catch (err) {
    console.error(`User Preference Read Error: ${err}`);
  }
  return void 0;
}
async function write(key, value) {
  try {
    await userPreferencesLocalForage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error(`User Preference Write Error: ${err}`);
  }
}
const userPreferences = {
  read: async () => await read(LS_USER_PREFERENCES),
  write: async (value) => {
    await write(LS_USER_PREFERENCES, value);
  }
};
export {
  LOCAL_STORAGE_KEY,
  STW_MY_WAREHOUSE_LOCAL_STORAGE_KEY,
  STW_POSTAL_CODE_LOCAL_STORAGE_KEY,
  userPreferences
};
